module.exports = __webpack_public_path__ + "img/logo.7c5689c7.png";